import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'

export default (feedback, type) => {
  let url;
  if(type === 'adminFeedback') url = `${axiosConfig.apiUrl}/rt/console/adminContact`
  else url = `${axiosConfig.apiUrl}/rt/console/feedback`
  return axios.post(url, feedback)  // removed 'axiosConfig.auth' as token is updated on login
  .then(res => {
    if (res.status === 200) {
      return true;
    } else {
      return false;
    }
  })
  .catch(err => {
    console.error(err);
    checkResponseErrorCodeAndRedirect(err);
    return false;
  })
}
